// extracted by mini-css-extract-plugin
export var list = "social-list-module--list--9Dadw";